import { useEffect } from 'react';

type InteractionHandler = (eventType: string, e: MouseEvent | TouchEvent) => void;

export function useInteraction<T extends HTMLElement | null>(ref: React.RefObject<T>, callback: InteractionHandler) {
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        const events: (keyof HTMLElementEventMap)[] = ['mousedown', 'mouseup', 'mouseleave', 'mousemove', 'touchstart', 'touchend', 'touchmove', 'wheel'];

        const handler = (e: Event) => {
            callback(e.type, e as MouseEvent | TouchEvent);
        };

        events.forEach((event) => element.addEventListener(event, handler));

        return () => {
            events.forEach((event) => element.removeEventListener(event, handler));
        };
    }, [ref, callback]);
}
